import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { Link } from "react-router-dom";
import logo from "./assets/images/logo.svg";
import logoCmetric from "./assets/images/logo-cmetric.png";

function Footer() {
  return (
    // <footer className="bg-light text-dark pt-5">
    //   <div className="container">
    //     <div className="row">
    //       <div className="col-md-4">
    //       <Link className="navbar-brand fw-bold" to="/">
    //         <img src={logoCmetric} alt="Logo" className="logo" />
    //       </Link>
    //         <p className="mt-4">
    //           Since 1995, C-Metric has been delivering decisive solutions for
    //           large enterprises and SMEs using our unique global delivery model.
    //           Our philosophy is to become a true technology partner with you by
    //           helping you achieve your own business goals.
    //         </p>
    //         <p>
    //           We can be successful only by making you successful. We promise to
    //           bring together the best technology talent and the most effective
    //           back-office services to help you compete effectively and win in
    //           the marketplace.
    //         </p>
    //         <img src="goodfirms.png" alt="GoodFirms" className="me-3" />
    //         <img src="ibm.png" alt="IBM Partner" />
    //       </div>
    //       <div className="col-md-2">
    //         <h4 className="secondary_text">Industries</h4>
    //         <ul className="list-unstyled">
    //           <li><Link to="/privacy-policy">Aviation</Link></li>
    //           <li><Link to="/privacy-policy">BFSI</Link></li>
    //           <li><Link to="/privacy-policy">Digital Marketing</Link></li>
    //           <li><Link to="/privacy-policy">E-Commerce</Link></li>
    //           <li><Link to="/privacy-policy">Education</Link></li>
    //           <li><Link to="/privacy-policy">FMCG</Link></li>
    //           <li><Link to="/privacy-policy">Healthcare</Link></li>
    //           <li><Link to="/privacy-policy">Logistics</Link></li>
    //         </ul>
    //       </div>
    //       <div className="col-md-2">
    //       <h4 className="secondary_text transparent_text">Transparent text</h4>
    //         <ul className="list-unstyled">
    //           <li><Link to="/privacy-policy">Trusted IBM Silver Partner</Link></li>
    //           <li><Link to="/privacy-policy">Manufacturing</Link></li>
    //           <li><Link to="/privacy-policy">Media & Entertainment</Link></li>
    //           <li><Link to="/privacy-policy">NGO</Link></li>
    //           <li><Link to="/privacy-policy">Real Estate</Link></li>
    //           <li><Link to="/privacy-policy">ISV</Link></li>
    //           <li><Link to="/privacy-policy">Telecom</Link></li>
    //           <li><Link to="/privacy-policy">Travel & Hospitality</Link></li>
    //           <li>
    //             <Link to="/privacy-policy">Privacy & Policy</Link>
    //           </li>
    //         </ul>
    //       </div>
    //       <div className="col-md-2">
    //         <h4 className="secondary_text">Technology</h4>
    //         <ul className="list-unstyled">
    //           <li><Link to="/privacy-policy">Microsoft Dynamics 365</Link></li>
    //           <li><Link to="/privacy-policy">Open Source Solution</Link></li>
    //           <li><Link to="/privacy-policy">Full Stack Development</Link></li>
    //           <li><Link to="/privacy-policy">WordPress</Link></li>
    //           <li><Link to="/privacy-policy">Cloud Application Development</Link></li>
    //           <li><Link to="/privacy-policy">Azure</Link></li>
    //         </ul>
    //       </div>
    //       <div className="col-md-2">
    //         <h4 className="secondary_text">Contact Us</h4>
    //         <p>
    //           <strong className="d-block">C-Metric</strong>             
    //           1221 North Church Street, Suite 202 Moorestown, NJ 08057
    //         </p>
    //         <p>
    //         <ul className="list-unstyled">
    //           <li><Link to="/privacy-policy">+1 (856) 482-7700</Link></li>
    //           <li> <Link to="/privacy-policy">info@c-metric.com</Link></li>
    //         </ul>                      
    //         </p>
    //       </div>
    //     </div>
    //     <div className="text-center mt-4 border-top ">
    //       <p className="mb-0 py-3">© 1995-2024 C-Metric Solutions Pvt Ltd. | All Rights Reserved</p>
    //     </div>
    //   </div>
    // </footer>
    <footer id="dk-footer" class="dk-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-4 position-relative">
            <div class="dk-footer-box-info">
              <Link className="navbar-brand fw-bold" to="https://www.c-metric.com/">
                <img src={logoCmetric} alt="Logo" className="logo" />
              </Link>
              <p class="footer-info-text">
              Since 1995, C-Metric has empowered enterprises and SMEs with innovative solutions, top talent, and efficient services to drive success.
              </p>
              <div class="footer-social-link">
                <h3>Follow us</h3>
                <ul>
                  <li>
                    <a href="https://www.facebook.com/CMetricSolution">
                      <i class="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/CMetricSolution">
                      <i class="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/cmetricsolution">
                      <i class="fa fa-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/CMetricSolution">
                      <i class="fa fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>

            </div>

            <div class="footer-awarad transparent_text">
              <p>Best Design Company 2019</p>
            </div>
          </div>

          <div class="col-md-12 col-lg-8">
            <div class="row">
              <div class="col-md-6">
                <div class="contact-us">
                  <div class="contact-icon">
                    <i class="fa fa-map-o" aria-hidden="true"></i>
                  </div>

                  <div class="contact-info">
                    <h3>C-Metric</h3>
                    <p>1221 North Church Street, Suite 202 Moorestown, NJ 08057</p>
                  </div>

                </div>

              </div>

              <div class="col-md-6">
                <div class="contact-us contact-us-last">                
                  <div class="contact-info ms-0">
                    <h3><i className="fa fa-phone me-3"></i><Link to="tel:+1(856)482-7700">+1 (856) 482-7700</Link></h3>
                    <h3><i className="fa fa-envelope me-3"></i><Link to="mailto:info@c-metric.com">info@c-metric.com</Link></h3>                                   
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div className="col-sm-12 col-md-6 col-lg-6">
              <div class="footer-widget footer-left-widget">
              <div class="section-heading">
                <h3>Useful Links</h3>
                <span class="animate-border border-black"></span>
                <ul className="navbar-nav mt-4">
                  <li className="nav-item">
                    <Link  to="/">
                      Home
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link  to="/login">
                      Login
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link  to="/register">
                      Register
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link  to="/invoice">
                     Invoice AI
                    </Link>
                  </li>
                </ul>
                </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6">
                <div class="footer-widget ">
                  <div class="section-heading">
                    <h3>Product</h3>
                    <span class="animate-border border-black"></span>
                    <div className="mt-4">
                      <Link className="navbar-brand fw-bold" to="/">
                        <img src={logo} alt="Logo" className="logo" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="copyright">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <span>Copyright © 2025, All Rights Reserved. Powered by C-Metric.</span>
            </div>

            <div class="col-md-6">
              <div class="copyright-menu">
                <ul>
                  <li>
                  <Link to="/privacy-policy">Privacy & Policy</Link>
                  </li>
                </ul>
              </div>
            </div>

          </div>

        </div>

      </div>



    </footer>
  );
}

export default Footer;
